import { render, staticRenderFns } from "./MInventories.vue?vue&type=template&id=fe5a1dac&scoped=true&"
import script from "./MInventories.vue?vue&type=script&lang=js&"
export * from "./MInventories.vue?vue&type=script&lang=js&"
import style0 from "./m-wms.scss?vue&type=style&index=0&id=fe5a1dac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5a1dac",
  null
  
)

export default component.exports